<template>
  <div class='tabbar'>
    <van-tabbar v-model="active"
                safe-area-inset-bottom
                inactive-color="#000"
                active-color="#E03232"
                class="tabbar_van"
                route
                :before-change="beforeChange">
      <van-tabbar-item to="/">
        <span>{{$t('text.home')}}</span>
        <template #icon="props">
          <img :src="props.active ?  '/static/newVersionImgs/mobile_tabbar_home_active.svg' : '/static/newVersionImgs/mobile_tabbar_home.svg'" >
        </template>
      </van-tabbar-item>
      <van-tabbar-item @click="openShareModal">
        <template>
          <el-tooltip v-model="isShowTips"
                      manual
                      placement="bottom"
                      popper-class="category_tooltip"
                      v-if="!$store.state.isPcClient">

            <img src="/static/newVersionImgs/mobile_tabbar_share.svg"
                 class="tabbar_item_van">
            <template slot="content">
              <div @click="closeTips">
                {{$t('navText.loginPanelText2')}}
                <span style="margin-left:5px">x</span>
              </div>
            </template>
          </el-tooltip>
        </template>
      </van-tabbar-item>
      <van-tabbar-item :to="userInfo?'/mine':'/login?login=1'">
        <span>{{$t('text.mine')}}</span>
        <template #icon="props">
          <img :src="props.active ?  '/static/newVersionImgs/mobile_tabbar_mine_active.svg' : '/static/newVersionImgs/mobile_tabbar_mine.svg'" >
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
export default{
    data() {
        return {
            active: 0,
            isShowTips: true
        }
    },
    props: {
        userInfo: {}
    },
    created() {
        if (window.localStorage.getItem('isShowTabBarTips') !== null) {
            this.isShowTips = JSON.parse(window.localStorage.getItem('isShowTabBarTips'))
        }
    },
    methods: {
        beforeChange(e) {
            return e !== 1
        },
        openShareModal() {
            !this.userInfo && document.body.clientWidth < 769 ? this.$router.push('/login?login=1') : this.$parent.openShareModal()
        },
        closeTips() {
            this.isShowTips = false
            window.localStorage.setItem('isShowTabBarTips', false)
        }
    }
}
</script>
<style lang='scss' scoped>
.tabbar{
    position: fixed;;
    bottom: 0;
    width: 100%;
    height: 4.5rem;
    background-color: #fff;
    z-index: 9;
    display: none;
    // box-shadow: 0 -10px 20px 0 RGBA(0, 0, 0, 0.1);

    .tabbar_van{
        height: 4.5rem;

        .tabbar_item_van{
            width: 50px;
            height: 50px;
            margin-bottom: 20px;
        }
    }
}

    @media screen  and (max-width: 768px){
        .tabbar{
        display: flex;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/TabBar.vue